<div class="footer-content">
  <div class="flex justify-between gap-2 p-2">
    <div class="flex items-center gap-2">
      <img src="assets/img/logo_taures_white.svg" alt="TauRes Logo" class="align-middle h-8" />
      <span class="hidden sm:block">© 2026 TauRes Gesellschaft für Investmentberatung mbH</span>
    </div>
    <div class="flex items-center gap-2">
      <a href="https://taures.de/impressum" target="_blank" class="linktext-regular">Impressum</a>
      <a href="https://taures.de/datenschutz" target="_blank" class="linktext-regular">Datenschutz</a>
    </div>
  </div>
</div>
